import { WageAndTravelReimbursementRequestStatus } from "../enums/watr-reimbursement-request-status";

export interface IWatrRequestWeeks {
    requestId: number,
    reimbursementId: number,
    status: WageAndTravelReimbursementRequestStatus,
    weekRequested: number,
    otherAmount?: number,
    approverUserId?: number | null,
    approvedDateTime?: string | Date | null,
    approverName?: string | null,
    reimbursedUserId?: number | null,
    reimbursedDateTime?: string | Date | null,
    reimbursedUserName?: string | null,
    createdDateTime: Date,
    lastUpdated: Date
}